export const warmupGrid = [
  [null, null, null, "X"],
  [null, 2,    1,    null],
  [8,    null, 3,    null],
  ["X",  null, null, "X"]
];

export const warmupFullGrid = [
  [null, null, null, "X", "X", "X", "X"],
  [null, 2,    1,    null, "X", "X", "X"],
  [8,    null, 3,    null, "X", "X", "X"],
  ["X",  null, null, "X", "X", "X", "X"],
  ["X",  "X",  "X",  "X", "X", "X", "X"],
  ["X",  "X",  "X",  "X", "X", "X", "X"],
  ["X",  "X",  "X",  "X", "X", "X", "X"]
];
